import styles from "@/styles/filterBarScheme.module.scss"
import { useState } from "react"
import { Skeleton } from "antd"
import GoogleADSense from "@/components/GoogleADSense"
import { fillterBarDictionary } from "@/utils/dictionary"
interface DAMNU_ENABLE {
  [key: string]: any, // 字段扩展声明
}

interface Props {
  onChange: Function;
  filterBarData: DAMNU_ENABLE;
  sidebarData: any
}

export default function FilterBar({ onChange, filterBarData, sidebarData }: Props) {

  return (
    <div className={styles['filterBar-box']}>
      <div className={styles['filterBar-list']}>
        {
          sidebarData.sidebarFilter.length > 0
            ?
            sidebarData.sidebarFilter.map((item: any, index: number) => {
              // 字典ID
              const dictionary = fillterBarDictionary.getValueByKey(item.key)
              if (item.items.length) {
                return (
                  <div className={styles['filterBar——item']} key={index}>
                    <div className={styles['filterBar——item_label']}>{item.title}</div>
                    <div className={styles['filterBar——item_content']}>
                      {
                        item.items.map((subItem: any, subIndex: number) => {
                          let isActive = false
                          // 判断筛选数据是否存在该值
                          if (filterBarData[item.key]) {
                            // 字典为1 custom-filtering时候需要特殊处理
                            if (dictionary === 1) {
                              isActive = filterBarData[item.key].description === subItem.description
                            } else {
                              isActive = filterBarData[item.key].name === subItem.name
                            }
                          }
                          return (
                            <div
                              className={`${styles['sortItem']} ${isActive && styles['active']}`}
                              onClick={() => { onChange({ key: item.key, ...subItem }) }}
                              key={subIndex}
                            >
                              {
                                // 字典为1 custom-filtering时候需要特殊处理
                                dictionary === 1
                                  ?
                                  `${subItem.name} ${subItem.description && `(${subItem.description})`}`
                                  :
                                  `${subItem.name} ${subItem.count ? `(${subItem.count})`: ''}`
                              }
                            </div>
                          )
                        })
                      }
                    </div>
                  </div>
                )
              }
            })
            :
            <div style={{ padding: "20px" }}>
              <Skeleton active />
            </div>
        }
      </div>
      <GoogleADSense />
    </div >
  )
}